import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Renderer_ThreeDotLoader.scss';
export const Renderer_ThreeDotLoader = (props) => {
    const style = {
        '--color': props.color,
        '--color-faded': props.fadedColor,
    };
    return _jsxs("span", { style: style, className: 'three-dot-loader', children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] });
};
//# sourceMappingURL=Renderer_ThreeDotLoader.js.map